const getAvailablePaymentMethods = async (countryCode = "", currency = "") => {
  try {
    const cacheKey = `${currency.toLowerCase()}_${countryCode.toLowerCase()}`;
    const paymentMethods = getCookie("paymentMethods");
    const parsedPaymentMethods = JSON.parse(paymentMethods || "{}");
    const savedPaymentMethod = parsedPaymentMethods[cacheKey];
    if (savedPaymentMethod) {
      return savedPaymentMethod;
    }

    const res = await apiFetchBrandServices(
      `/api/processor-map/providers?countryCode=${countryCode}&currency=${currency}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setCookie(
      "paymentMethods",
      JSON.stringify({ [cacheKey]: res.orderedMethods })
    );
    return res.orderedMethods;
  } catch (error) {
    logger.error(error);
    return {};
  }
};
class AfterpayMessaging extends HTMLElement {
  constructor() {
    super();
    this.currency = this.dataset.currency;
    this.countryCode = this.dataset.countryCode;
    this.infoLabel = this.querySelector(".afterpay-messaging-container__info");
    this.load();
    this.initEvent();
  }

  isAfterPayEnabled(paymentMethods = []) {
    let isEnabled = false;
    if (Array.isArray(paymentMethods)) {
      isEnabled = paymentMethods.indexOf("afterpay") !== -1;
    }
    return isEnabled;
  }

  initEvent() {
    window.addEventListener("Afterpay.ready", () => {
      this.infoLabel.innerHTML = theme.translations.available_for_non_subs;
      this.style.display = "block";
      this.closest(".afterpay-messaging-container").style.display = "block";
    });
  }

  load() {
    getAvailablePaymentMethods(this.countryCode, this.currency)
      .then((methods) => {
        if (this.isAfterPayEnabled(methods)) {
          loadScript("https://js.afterpay.com/afterpay-1.x.js");
        }
      })
      .catch((err = {}) => {
        logger.error(err);
      });
  }
}
customElements.define("afterpay-messaging-container", AfterpayMessaging);
